class ZoomComponent extends HTMLElement {
    constructor() {
        super();

        const imgContainerElements = this.querySelectorAll('.product__media-item .media');
        const imgContainer = this.querySelector('.product__media-list');
      
        // Zoom Percentage
        const ZOOM = 185;
      
        imgContainerElements.forEach((containerEl, index) => {
      
          let imageElement = containerEl.firstElementChild;
      
          // Mouse enter event
          containerEl.addEventListener('mouseenter', () => {
            imageElement.style.width = ZOOM + '%';
            imageElement.style.height = ZOOM + '%';
            imageElement.style.maxWidth = 'none';
          })
      
          // Mouse leave event
          containerEl.addEventListener('mouseleave', () => {
            imageElement.style.width = '100%';
            imageElement.style.height = '100%';
            imageElement.style.top = '0';
            imageElement.style.left = '0';
          })
      
          // Mouse move event
          containerEl.addEventListener('mousemove', function(mouseEvent){
            let obj = imgContainer;
            let obj_left = 0;
            let obj_top = 0;
            let xpos;
            let ypos;
      
            while (obj.offsetParent) {
              obj_left += obj.offsetLeft;
              obj_top += obj.offsetTop;
              obj = obj.offsetParent;
            }
        
            if(mouseEvent) {
              //Firefox
              xpos = mouseEvent.pageX;
              ypos = mouseEvent.pageY;
        
            } else {
              //IE
              xpos = window.event.x + document.body.scrollLeft - 2;
              ypos = window.event.y + document.body.scrollTop - 2;
            }
        
            xpos -= obj_left;
            ypos -= obj_top;
      
            const imgWidth = imageElement.clientWidth;
            const imgHeight = imageElement.clientHeight;
      
            imageElement.style.top = -(((imgHeight - this.clientHeight) * ypos) / this.clientHeight) + 'px';
            imageElement.style.left = -(((imgWidth - this.clientWidth) * xpos) / this.clientWidth) + 'px';
          })
        })
    }
}

customElements.define('zoom-component', ZoomComponent);